export default __webpack_public_path__ + "static/media/delete-btn.ef2414fb.svg";